var scope_0 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0476d32e402a442bb632b3c74721f664.js').default;

var scope_1 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/08016bf407b05ae123946dd4b85ad12e.js').default;

var scope_2 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e9a1132bc2af5c875303553c8e334ac.js').default;

var scope_3 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1487204f9153f8b84ff6fcd34c5a60ed.js').default;

var scope_4 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/18cb872ccb3d6237c414338922470652.js').default;

var scope_5 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a5332056a16bcfdaab1fe94bd47318b.js').default;

var scope_6 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/47faf815dda7334413a1c63d21aad513.js').default;

var scope_7 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6d3e6ad8f2c17bc0a119032638bdd0fb.js').default;

var scope_8 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/71259517b50396b50d947f6cba29f643.js').default;

var scope_9 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8abf957185c1e83b1c9fd1ddd8f5e922.js').default;

var scope_10 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9c121523c95060efbc65e2e7126f64da.js').default;

var scope_11 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a21ce15a56b3c0490c336d214554675e.js').default;

var scope_12 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bc561992007d38a58030944ddf137719.js').default;

var scope_13 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e7ee5c4a309c416c5ef30ad213a3cbee.js').default;

var scope_14 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_15 = require('/opt/build/repo/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f40459bcdd3d9fa9acba432622898601.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}